import { logout } from 'services/auth';
import { useNavigate } from 'react-router-dom';
import { setName, setEmail, setRole, useMaterialUIController } from 'context';
import { useEffect } from 'react';
function Logout() {
  const navigate = useNavigate();
  const [, dispatch] = useMaterialUIController();
  useEffect(() => {
    logout()
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setName(dispatch, null);
        setEmail(dispatch, null);
        setRole(dispatch, null);
        document.cookie = 'access_token=; Max-Age=0; path=/';
        navigate('/authentication/sign-in/basic');
      });
  }, []);
  return <></>;
}

export default Logout;
